export const SelectLanguageModel = null

export const LANGUAGE_LIST_DATA = []
